// extracted by mini-css-extract-plugin
export var chevron = "_j6-2";
export var dropdownItems = "_j6-0";
export var item = "_j6-1";